import React, { useState } from 'react';
import { IconCross, IconUsers, IconX } from '@tabler/icons-react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../context/AppContext';
import LogoutModal from '../../../../utils/LogoutModal';

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const navigate = useNavigate();
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const logout = () => {
    console.log("logout");
    navigate('/logout');
  }

  const handleLogout = (e) => {
    e.preventDefault();
    console.log("logout modal");
    setIsDrawerOpen(false);
    setIsLogoutModalOpen(true);
  }

  const handleCancel = () => {
    console.log("cancel logout");
    setIsLogoutModalOpen(false);
  };
  const {user} = useAppContext();
  const otherLinks = [
    {
      name: 'Profile',
      link: '/patient/profile',
    },
    {
      name:'Logout',
      link:'/logout',
    }
]

  const design = (
    <>
          <div className="w-full header top-0 shadow-md" style={{     // Set the desired height for the div
            backgroundImage: 'url(/drippingsmall.png)',
            backgroundRepeat: 'repeat-x' ,
            backgroundSize: 'auto 60%',
            backgroundPosition: 'top',
            backgroundColor: 'rgba(255, 255, 255, 0.2)', // White overlay
            backgroundBlendMode: 'lighten', // Blend image with white color
          }}>
      <header className="flex justify-between items-center p-4 bg-fmb-secondary text-white">
      <div className="flex fmb-logo-header items-center space-x-2">
          <img onClick={()=>navigate('/')} src="/logonav.png" alt="Logo" className="h-14" />
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="text-right">
            <div className="text-sm font-medium text-slate-700">{user?.name || user?.username?.split('@')[0]}</div>
            <div className="text-xs text-black">{user?.role?.toUpperCase()}</div>
          </div>
          <button onClick={toggleDrawer} className="focus:outline-none">
            <IconUsers className="text-gray-800" />
          </button>
        </div>
      </header>

      {/* Drawer */}
      <div
        className={`flex flex-col flex-wrap content-start fixed z-10 top-0 right-0 w-full md:w-1/2 h-full bg-white shadow-lg transition-transform transform ${
          isDrawerOpen ? 'translate-x-1/3' : 'translate-x-full'
        }`}
      >
        <button className="p-4 w-2/3 flex justify-between">
          <span className='flex flex-row gap-2'><IconUsers style={{fontSize:"x-large"}}/> {user?.name || user?.username?.split('@')[0]}</span>
          <IconX onClick={toggleDrawer} style={{fontSize:"x-large"}}/>
        </button>
        <nav className="w-full text-left p-4">
          <ul>
          {otherLinks.map((navDetails) => (
                  <li className="mb-2 p-3 border-b-2 border-b-fmb">
                  {
                                      navDetails.name === "Logout"?
                                      <NavLink to={navDetails.link} onClick={handleLogout} className="text-gray-800">{navDetails.name}</NavLink>
                                      :
                                      <NavLink to={navDetails.link} onClick={toggleDrawer} className="text-gray-800">{navDetails.name}</NavLink>
                                      }
                </li>
                ))
              }
          </ul>
        </nav>
      </div>
    </div>    
    {isLogoutModalOpen && <LogoutModal isopen={isLogoutModalOpen} onConfirm={logout} onCancel={handleCancel} />}
    </>
  );

  return design
};

export default Header;
